// https://github.com/zesik/react-splitter-layout
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import SplitterLayout from 'react-splitter-layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Selections from './Selections/Selections';
import Pagination from './Pagination/Pagination';
import Facets from './Facets/Facets';
import s from './panels.module.css';

const Panels = ({ location, match }) => {
  const { tabs } = useSelector(state => ({
    tabs: state.tabs
  }));
  // these could be added in redux state to remember which is open for each tab
  const [leftPanelIsOpen, setLeftPanelIsOpen] = useState(true);
  const [rightPanelIsOpen, setRightPanelIsOpen] = useState(true);

  const { tabId } = match.params;
  if (!tabs || !tabs[tabId]) return <Redirect to='/datasets' />;

  const mapIsAvailiable = (tabs[tabId].dataset.geo === 'Yes');

  const toggleLeftPanel = () => setLeftPanelIsOpen(!leftPanelIsOpen);
  const toggleRightPanel = () => setRightPanelIsOpen(!rightPanelIsOpen);

  const caretLeft = leftPanelIsOpen ? 'caret-left' : 'caret-right';
  const caretRight = (rightPanelIsOpen) ? 'caret-right' : 'caret-left';

  if (leftPanelIsOpen) {
    return (
      <>
        <SplitterLayout primaryIndex={0} percentage primaryMinSize={15} secondaryInitialSize={70}>
          <Facets {...{ tabs, location }} />
          <div className={s.fixScroll}>
            <SplitterLayout percentage secondaryMinSize={12} secondaryInitialSize={20}>
              <div className='position-relative h-100 w-100'>
                <div className={s.panelButton} onClick={toggleLeftPanel}>
                  <FontAwesomeIcon icon={['fas', caretLeft]} color='#404040' className={`${s.caret} ${s.cLeft}`} />
                </div>
                <Pagination {...{ tabId, mapIsAvailiable }} />
                <div className={`${s.panelButton} ${s.panelButtonRight}`} onClick={toggleRightPanel}>
                  <FontAwesomeIcon icon={['fas', caretRight]} color='#404040' className={`${s.caret} ${s.cRight}`} />
                </div>
              </div>
              {rightPanelIsOpen && <Selections />}
            </SplitterLayout>
          </div>
        </SplitterLayout>
      </>
    );
  }

  if (!leftPanelIsOpen && !rightPanelIsOpen) {
    return (
      <div className={s.fixScroll}>
        <SplitterLayout>
          <div className='position-relative h-100 w-100'>
            <div className={s.panelButton} onClick={toggleLeftPanel}>
              <FontAwesomeIcon icon={['fas', 'caret-right']} color='#404040' className={`${s.caret} ${s.cLeft}`} />
            </div>
            <Pagination {...{ tabId, mapIsAvailiable }} />
            <div className={`${s.panelButton} ${s.panelButtonRight}`} onClick={toggleRightPanel}>
              <FontAwesomeIcon icon={['fas', 'caret-left']} color='#404040' className={`${s.caret} ${s.cRight}`} />
            </div>
          </div>
        </SplitterLayout>
      </div>
    );
  }

  if (!leftPanelIsOpen && rightPanelIsOpen) {
    return (
      <>
        <SplitterLayout percentage primaryIndex={1} primaryMinSize={10}>
          {/* do not remove style={{ height: 'calc(100% - 25px)' }}, see comment in Pagination */}
          <div className='position-relative w-100' style={{ height: 'calc(100% - 25px)' }}>
            <div className={s.panelButton} onClick={toggleLeftPanel}>
              <FontAwesomeIcon icon={['fas', caretLeft]} color='#404040' className={`${s.caret} ${s.cLeft}`} />
            </div>
            <Pagination {...{ tabId, mapIsAvailiable }} view='leftPanelIsNotOpen && rightPanelIsOpen' />
            <div className={`${s.panelButton} ${s.panelButtonRight}`} onClick={toggleRightPanel}>
              <FontAwesomeIcon icon={['fas', caretRight]} color='#404040' className={`${s.caret} ${s.cRight}`} />
            </div>
          </div>
          <Selections />
        </SplitterLayout>
      </>
    );
  }

  return '';
};

export default Panels;
